var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};


//////////////////
// WEBPACK FOOTER
// ../~/react-helmet/~/core-js/modules/_has.js
// module id = 438
// module chunks = 3